import React from 'react';

export const InputIcon = () => {
  return <div>InputIcon</div>;
};
